import { render, staticRenderFns } from "./ShippoAddressPostcode.vue?vue&type=template&id=f31ed8ac&"
import script from "./ShippoAddressPostcode.vue?vue&type=script&lang=ts&"
export * from "./ShippoAddressPostcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports